var _defs, _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgYi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "uuid-dd66b68a-c9cd-4834-8f3f-b9d422336344",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .uuid-9aa433c7-fe6f-4d84-a1f4-e298036425da {\n        fill: #f2f2f2;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "uuid-9aa433c7-fe6f-4d84-a1f4-e298036425da",
    d: "M20.71,10.49c-1.45,1.7-2.89,3.39-4.32,5.09-.07.08-.11.2-.11.31,0,2.28,0,4.55,0,6.83,0,.51-.29.87-.77.94-.44.07-.88-.24-.96-.68-.02-.11-.02-.22-.02-.33,0-2.36,0-4.72,0-7.08,0-.35.1-.63.33-.9,1.59-1.86,3.17-3.73,4.76-5.59.33-.38.84-.45,1.22-.16.38.29.45.8.17,1.21-.08.12-.18.22-.28.35Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "uuid-9aa433c7-fe6f-4d84-a1f4-e298036425da",
    d: "M12.74,14.22c-.29-.05-.49-.2-.66-.41-1.11-1.36-2.22-2.71-3.33-4.06-.25-.31-.33-.65-.15-1.01.16-.34.46-.49.82-.48.29,0,.5.16.68.37.76.93,1.51,1.85,2.27,2.78.37.45.73.89,1.1,1.34.24.29.33.62.16.97-.17.36-.48.51-.88.51Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "uuid-9aa433c7-fe6f-4d84-a1f4-e298036425da",
    d: "M22.09,23.04c-.2.62-.73.88-1.26.61-.29-.15-.47-.39-.47-.72,0-1.54,0-3.08,0-4.62,0-.46.41-.82.87-.82.45,0,.86.37.86.83,0,1.57,0,3.13,0,4.72Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "uuid-9aa433c7-fe6f-4d84-a1f4-e298036425da",
    d: "M21.38,14.8c.13-.57.56-.91,1.09-.88.55.03.97.43,1.02.95.05.53-.29,1-.81,1.14-.72.19-1.42-.45-1.3-1.22Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYi);
export default __webpack_public_path__ + "static/media/Yi.912be652af8b9cc5ca155e40a40743fe.svg";
export { ForwardRef as ReactComponent };